import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Layout} from 'antd';
import { Link } from 'react-router-dom';

import './auth.css';
import LandingHeader from "../landing/common/Header";
import LandingFooter from "../landing/common/Footer";

const { Content } = Layout;


class AuthForm extends React.Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    error: PropTypes.string,
    children: PropTypes.element.isRequired
  }

  render () {
    return (
      <Layout className='auth-layout landing'>
        <LandingHeader isLoggedIn={false}>
          <Link to="/">
            <span>Conduster</span>
          </Link>
        </LandingHeader>
        <Content className="login-form">
          <h3 className="login-title">
            {this.props.title}
          </h3>

          {this.props.children}

          {this.props.error &&
            (<div style={{textAlign: 'center'}} className='ant-form-item-control-wrapper has-error'>
              <div className='ant-form-explain'>
                {this.props.error}
              </div>
            </div>)
          }
        </Content>
        <LandingFooter/>
      </Layout>
    )
  }
}

export default AuthForm;


// WEBPACK FOOTER //
// ./src/components/login/auth.js